export const isRidewithgps = (urlOrCode: string) => {
  return !!urlOrCode.match('ridewithgps.com');
};
